import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen, faUser, faCalendar, faArrowRight } from '@fortawesome/free-solid-svg-icons';

const CustomCardArticles = ({title, author, id, photo}) => {
  const [imageError, setImageError] = useState(false);
  const defaultImage = '/images/article.png';
  const articleImage = photo && !imageError ? photo : defaultImage;

  return (
    <div className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 border border-gray-100">
      {/* Image Container with Overlay */}
      <div className="relative h-56 overflow-hidden">
        <img 
          src={articleImage}
          alt={title}
          onError={() => setImageError(true)}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500"></div>
        
        {/* Floating Badge */}
        <div className="absolute top-4 right-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-full text-xs font-semibold shadow-lg backdrop-blur-sm bg-opacity-90">
          <FontAwesomeIcon icon={faBookOpen} className="mr-2" />
          Article
        </div>

        {/* Read Time (Optional - can be dynamic) */}
        <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-xs font-medium shadow-md">
          <FontAwesomeIcon icon={faCalendar} className="mr-1 text-purple-600" />
          Nouveau
        </div>
      </div>

      {/* Content */}
      <div className="p-6 relative">
        {/* Author */}
        <div className="flex items-center mb-3 text-sm text-gray-600">
          <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center mr-2 shadow-md">
            <FontAwesomeIcon icon={faUser} className="text-white text-xs" />
          </div>
          <span className="font-medium truncate" title={author}>
            {author}
          </span>
        </div>

        {/* Title */}
        <h3 
          className="text-xl font-bold text-gray-800 mb-4 leading-tight line-clamp-2 group-hover:text-purple-600 transition-colors duration-300 min-h-[3.5rem]"
          title={title}
        >
          {title}
        </h3>

        {/* Divider */}
        <div className="w-16 h-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full mb-4 group-hover:w-full transition-all duration-500"></div>

        {/* Read More Button */}
        <NavLink 
          to={`/article/${id}`}
          className="group/btn relative inline-flex items-center justify-center w-full px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 no-underline"
        >
          {/* Button Background Animation */}
          <span className="absolute inset-0 bg-gradient-to-r from-pink-600 to-purple-600 opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></span>
          
          {/* Button Content */}
          <span className="relative flex items-center">
            <FontAwesomeIcon icon={faBookOpen} className="mr-2" />
            Lire l'article
            <FontAwesomeIcon 
              icon={faArrowRight} 
              className="ml-2 transform group-hover/btn:translate-x-1 transition-transform duration-300" 
            />
          </span>
        </NavLink>

        {/* Decorative Corner Elements */}
        <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-purple-200 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-tr-2xl"></div>
        <div className="absolute bottom-0 left-0 w-16 h-16 border-b-2 border-l-2 border-pink-200 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-bl-2xl"></div>
      </div>

      {/* Shine Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 transform -translate-x-full group-hover:translate-x-full transition-all duration-1000 pointer-events-none"></div>

      <style jsx>{`
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .no-underline {
          text-decoration: none !important;
        }
        
        .no-underline:hover {
          text-decoration: none !important;
        }
      `}</style>
    </div>
  );
};

export default CustomCardArticles;